import { createAction, props } from '@ngrx/store';
import { OracleStorageActionModel } from '@models/common/oracle-storage-action.model';
import { PolicyModel } from '@models/configuration/policy.model';

export const createPolicy = createAction(
    '[Policy] Create Policy',
    props<{ action: OracleStorageActionModel<PolicyModel> }>()
);

export const createPolicySuccess = createAction(
    '[Policy] Create Policy Success',
    props<{ Policy: PolicyModel }>()
);

export const searchPolicies = createAction(
    '[Policies] Search Policies',
    props<{ action: OracleStorageActionModel<PolicyModel> }>()
);

export const searchPoliciesSuccess = createAction(
    '[Policies] Search Policies Success',
    props<{ Policies: PolicyModel[] }>()
);

export const updatePolicy = createAction(
    '[Policy] Update Policy',
    props<{ action: OracleStorageActionModel<PolicyModel> }>()
);

export const updatePolicySuccess = createAction(
    '[Policy] Update Policy Success',
    props<{ Policy: PolicyModel }>()
);

export const selectPolicy = createAction(
    '[Policy] Select Policy',
    props<{ Policy: PolicyModel }>()
);

export const setCurrentPolicy = createAction(
    '[Policy] Current Policy',
    props<{ rowKey: string | null }>()
);

export const deletePolicy = createAction(
    '[Policy] Delete Policy',
    props<{ action: OracleStorageActionModel<PolicyModel> }>()
);

export const deletePolicySuccess = createAction(
    '[Policy] Delete Policy Success',
    props<{ Policy: PolicyModel }>()
);

export const resetLoading = createAction(
    '[Loading] Reset Loading Success'
);